module.exports = __webpack_public_path__ + "fonts/icomoon.5f83c0cff4b2aae279d97f43317ac508.woff";